import React, { useCallback } from 'react';
import { Button, IconButton_IconSizes } from '@ydistri/ds';
import { MdWarning } from 'react-icons/md';
import { AvailableModals, openModal } from '../../Modals/modalSlice';
import { plural } from '@ydistri/generic-utils';
import { useAppDispatch } from '../../../store';
import { useStoresReport } from './useStoresReport';
import { flaggedStores } from './storesReportLib';

const SalesNoticeButton: React.FC = () => {
  const dispatch = useAppDispatch();

  const { problems, isLoading } = useStoresReport();
  const flagged = flaggedStores(problems);

  const openStoreInfoHandler = useCallback(() => {
    dispatch(
      openModal({
        type: AvailableModals.STORE_SALE_INFO,
        data: undefined,
      }),
    );
  }, [dispatch]);

  if (flagged.length === 0) return null;

  return (
    <Button
      $colorVariant="ghostDanger"
      onClick={openStoreInfoHandler}
      data-testid="store_info"
      loading={isLoading}
    >
      <MdWarning size={IconButton_IconSizes.small} />
      {plural(flagged.length, `${flagged.length} flagged store`)}
    </Button>
  );
};

export default SalesNoticeButton;
